import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { authInterceptor, domainInterceptor, provideDomainConfig } from '@fy-web-2/core';
import { provideAuthApiConfig, provideAuthBootstrap } from '@fy-web-2/state-auth';
import { provideTenantApiConfig, provideTenantBootstrap } from '@fy-web-2/state-tenant';
import { environment } from '../environments/environment';
import { appRoutes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(appRoutes, withComponentInputBinding()),
    // Order matters: `domainInterceptor` runs first so `referer-domain` is
    // attached to every request — including unauthenticated ones like login.
    provideHttpClient(withInterceptors([domainInterceptor, authInterceptor])),

    provideDomainConfig({
      localHostName: environment.localHostName,
    }),

    provideAuthApiConfig({
      baseUrl: environment.apiUrl,
      clientId: environment.clientId,
      clientSecret: environment.clientSecret,
    }),
    provideAuthBootstrap(),

    // Tenant theming/branding — reuses the same apiUrl as auth. The tenant
    // bootstrap runs as an APP_INITIALIZER so the first paint is already
    // branded from cache; the live `domain-data` refresh happens on login.
    provideTenantApiConfig({ baseUrl: environment.apiUrl }),
    provideTenantBootstrap(),

    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: '.app-dark',
          cssLayer: {
            name: 'primeng',
            order: 'tailwind-base, primeng, primeng-overrides, tailwind-utilities',
          },
        },
      },
    }),
  ],
};
